<template>
  <v-chip :color="statusBgColor" class="white--text">{{ status | capitalize }}</v-chip>
</template>

<script>
export default {
  props: {
    status: {
      required: true
    }
  },
  computed: {
    statusBgColor() {
      switch (this.status) {
        case 'confirmed':
          return 'success'
        case 'queued':
          return 'orange'
        case 'pending':
          return 'primary'
        case 'error':
        case 'queue_error':
          return 'red'
        case 'expired':
          return 'black'
        default:
          return ''
      }
    }
  },
  name: "ImportStatus"
}
</script>

<style scoped>

</style>